import { cn } from '../../utils/cn';
const baseClasses = 'inline-flex h-10 cursor-pointer items-center justify-center rounded-full px-4 text-label-m transition-colors duration-150 ease-slide';
// Shared foreground for the light-surface variants: neutral-800 (#212222) → neutral-900 (#131414).
const darkText = 'text-interactive hover:text-interactive-hover';
// Disabled/loading appearance, driven by base-ui's `data-disabled` styling hook (Button only).
const disabledClasses = 'data-disabled:cursor-not-allowed data-disabled:border-transparent data-disabled:bg-interactive-disabled data-disabled:text-interactive-disabled';
const variantClasses = {
    pink: cn('bg-interactive-inverse-loud', darkText),
    black: 'bg-interactive-inverse hover:bg-interactive-inverse-hover text-interactive-inverse hover:text-interactive-inverse-hover',
    grey: cn('bg-interactive hover:bg-interactive-loud', darkText),
    ghost: 'border-static border bg-transparent text-static',
    'ghost-inverse': 'border-static border bg-transparent text-static-inverse',
};
// Single source of Tailwind classes shared by `Button` (an action) and `ButtonLink` (navigation).
export const buttonStyles = ({ variant = 'pink', className, }) => cn(baseClasses, disabledClasses, variantClasses[variant], className);
